module.exports = __webpack_public_path__ + "img/guanwang.cb238dbd.svg";